

    export default {
        validationAttemptedBindingName: '$validationAttempted'
    }
